module.exports = __webpack_public_path__ + "c9d914851ce4334dedc11253d3bc7db6.png";